import { AiModelsApi, SupportedAiModelResponse } from "../../../@api";

import { IStoreContext } from "../../stores/StoreContext";
import { AiModelsApiService } from "../ApiServices/AiModelApiService";
import GenericService from "../GenericService";

export class AiModelsService extends GenericService<AiModelsApi, AiModelsApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, AiModelsApi, AiModelsApiService);
  }

  public async aiModelsGetSupportedImageModels(): Promise<Array<SupportedAiModelResponse>> {
    return this.apiService.aiModelsGetSupportedImageModels();
  }

  public getSupportedChatModel(): Promise<SupportedAiModelResponse> {
    return this.apiService.aiModelsGetSupportedChatModel();
  }
}
